import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-whatsapp-icon',
  templateUrl: './whatsapp-icon.component.html',
})

export class WhatsappIconComponent {
  @Input() color: string = '';
}
